import React from "react";
import SearchControlls from "./src/searchControlls";
import UserDataView from "./src/userDataView";
import FileDialog from "./src/fileDialog";

const BookingOverviewContainer = (): React.JSX.Element => (
  <React.Fragment>
    <SearchControlls />
    <UserDataView />
    <FileDialog />
  </React.Fragment>
);

export default BookingOverviewContainer;
